import type { SVGProps } from 'react';

interface AlertCircleOutlineIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function AlertCircleOutlineIcon({ className, ...props }: AlertCircleOutlineIconProps) {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <circle cx="7" cy="7" r="6.5" stroke="currentColor" />
      <path
        d="M6.5 7.66632V3.66662C6.5 3.29845 6.79848 3 7.16667 3C7.53486 3 7.83333 3.29845 7.83333 3.66662V7.66632C7.83333 8.03448 7.53486 8.33293 7.16667 8.33293C6.79848 8.33293 6.5 8.03448 6.5 7.66632Z"
        fill="currentColor"
      />
      <ellipse
        cx="7.17112"
        cy="10.3326"
        rx="0.671115"
        ry="0.666617"
        fill="currentColor"
      />
    </svg>
  );
}
